if (typeof ComplementaryProducts === 'undefined') {
class ComplementaryProducts extends HTMLElement {
    constructor() {
        super();
        this.productId = this.getAttribute('recommendation-product-id');
        this.recommendationType = this.getAttribute('recommendation-type');
        this.recommendationSectionName = this.getAttribute(
            'recommendation-section'
        );
        // Check if productRecommendations are loaded and use it in condition to prevent re-render of product
        this.didProductRecommendationLoad = false;
        this.elObj = {
            recommendationEl: '[products-data]',
            recommendationTitle: '[title]',
            addAllButton: '[data-add-all-btn]',
        };
        // Listen for event when component is in view
        this.addEventListener('observe:elementInView', () => {
            if (this.didProductRecommendationLoad) return;
            this.fetchData();
        });
    }

    queryHTMLData(htmlString, elementToQuery) {
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        return html.querySelector(elementToQuery).innerHTML;
    }

    renderTitle() {
        const getSectionTitle =
            this.querySelector('template').content.firstElementChild.cloneNode(
                true
            );

        this.prepend(getSectionTitle);
    }

    showProductLayout() {
        this.classList.remove('recommendation-inactive');
        this.copyPriceForMobileLayout();
        this.setupAddAllButton();
    }

    copyPriceForMobileLayout() {
        const productForms = this.querySelectorAll('form.cart-recommendation-add-item-form');

        productForms.forEach(form => {
            const priceElementText = form.closest('.recommendation__form--wrapper').querySelector('.price').textContent;

            form.closest('.recommendation__item--inner-content').querySelector('.recommendation__middleBlock--price').textContent = priceElementText;
        });
    }

    setupAddAllButton() {
        const addAllBtn = this.querySelector(this.elObj.addAllButton);
        if (addAllBtn) {
            addAllBtn.addEventListener('click', () => this.addAllToCart());
            this.updateAddAllButtonText();

            // Listen for quantity changes to update price
            this.addEventListener('change', (e) => {
                if (e.target.name === 'quantity') {
                    this.updateAddAllButtonText();
                }
            });
        }
    }

    getAllProductVariants() {
        const productForms = this.querySelectorAll('form.cart-recommendation-add-item-form');
        const variants = [];

        productForms.forEach(form => {
            const variantIdInput = form.querySelector('input[name="id"]');
            const quantityInput = form.querySelector('input[name="quantity"]') || { value: 1 };
            const priceElement = form.closest('.recommendation__form--wrapper').querySelector('.price');

            if (variantIdInput && variantIdInput.value) {
                // const price = this.extractPriceInCents(priceElement?.textContent || '');
                const price = priceElement?.textContent.replace(/[^0-9.-]+/g, '');
                console.log('price', price);
                variants.push({
                    id: variantIdInput.value,
                    quantity: 1,
                    price: price
                });
            }
        });

        return variants;
    }

    extractPriceInCents(priceString) {
        const numericString = priceString.replace(/[^0-9.-]+/g, '');
        console.log('extractPriceInCents', numericString);
        const priceFloat = parseFloat(numericString);
        return isNaN(priceFloat) ? 0 : Math.round(priceFloat * 100);
    }

    calculateTotalPrice(variants) {
        return variants.reduce((total, variant) => {
            return total + (variant.price * variant.quantity);
        }, 0);
    }

    formatPrice(cents) {
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'EUR'
        }).format(cents / 100);
    }

    updateAddAllButtonText() {
        const addAllBtn = this.querySelector(this.elObj.addAllButton);
        if (!addAllBtn) return;

        const variants = this.getAllProductVariants();
        const totalPrice = this.calculateTotalPrice(variants);

        if (variants.length > 0 && totalPrice > 0) {
            addAllBtn.textContent = `Commander toute la routine - ${this.formatPrice(totalPrice)}`;
        } else {
            addAllBtn.textContent = 'Commander toute la routine';
        }
    }

    updateCartCount(result) {
        // Get item count from the result - it's in items.length, not item_count
        const itemCount = result.items ? result.items.length : 0;
        console.log('Total items added:', itemCount);

        // Update cart count from sections if available
        if (result.sections && result.sections['cart-count-bubble']) {
            const bubbleHTML = result.sections['cart-count-bubble'];
            const parser = new DOMParser();
            const doc = parser.parseFromString(bubbleHTML, 'text/html');
            const bubbleElement = doc.querySelector('cart-count-bubble') || doc.querySelector('[id*="cart-count"]');

            console.log('Cart count bubble HTML:', bubbleHTML);
            console.log('Parsed bubble element:', bubbleElement);

            if (bubbleElement) {
                // Find the target element in the actual DOM
                const targetElement = document.querySelector('cart-count-bubble') ||
                                    document.querySelector('[id*="cart-count"]') ||
                                    document.querySelector('cart-count');

                console.log('Target element in DOM:', targetElement);

                if (targetElement) {
                    targetElement.outerHTML = bubbleElement.outerHTML;
                    console.log('Updated cart count bubble');
                } else {
                    console.warn('Target cart count element not found in DOM');
                }
            }
        }
    }

    async addAllToCart() {
        const variants = this.getAllProductVariants();

        if (variants.length === 0) {
            console.warn('No products found to add to cart');
            return;
        }

        const addAllBtn = this.querySelector(this.elObj.addAllButton);
        const cartType = 'cart-drawer';

        if (addAllBtn) {
            addAllBtn.disabled = true;
            addAllBtn.textContent = 'Ajout...';
        }

        const formData = new FormData();
        variants.forEach((variant, index) => {
            formData.append(`items[${index}][id]`, variant.id);
            formData.append(`items[${index}][quantity]`, variant.quantity);
        });
        formData.append(
            'sections',
            HELPER_UTIL.sectionRenderUtil(cartType).getSectionsString()
        );
        formData.append(
            'sections_url',
            `${Shopify.routes.root}cart`
        );

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Cart add result:', result);

                if (addAllBtn) {
                    addAllBtn.disabled = false;
                    addAllBtn.textContent = 'Ajoutée au panier';
                    setTimeout(() => {
                        this.updateAddAllButtonText();
                    }, 2000);
                }

                // Update cart count manually
                this.updateCartCount(result);

                // Fetch and update cart drawer using the updateAndShowCart event
                // This approach fetches fresh cart data instead of using potentially empty sections
                const cartDrawer = document.querySelector('drawer-cart');
                console.log('Cart drawer element:', cartDrawer);

                if (cartDrawer) {
                    window.currentActiveElement = addAllBtn;

                    // Trigger cart fetch and update
                    HELPER_UTIL.dispatchCustomEvent(
                        'action:cart:updateCartandShowCart',
                        document
                    );
                }
            } else {
                throw new Error('Failed to add products to cart');
            }
        } catch (error) {
            console.error('Error adding products to cart:', error);
            if (addAllBtn) {
                addAllBtn.disabled = false;
                this.updateAddAllButtonText();
            }

            if (error.json) {
                error.json().then((errorObj) => {
                    if (errorObj.status === 422) {
                        HELPER_UTIL.dispatchCustomEvent(
                            'action:product:triggerVariantAddToCartError',
                            document,
                            {
                                errorObj: errorObj.description,
                            }
                        );
                    }
                });
            }
        }
    }

    generateProductLayouts(textData) {
        const returnedHTMLAfterQuery = this.queryHTMLData(
            textData,
            this.elObj.recommendationEl
        );
        if (returnedHTMLAfterQuery && returnedHTMLAfterQuery.trim()) {
            try {
                const elToAppendData = this.querySelector(
                    this.elObj.recommendationEl
                );
                elToAppendData.innerHTML = returnedHTMLAfterQuery;
                this.renderTitle();
                this.showProductLayout();
            } catch (error) {
                console.log(error);
            }
        } else {
            this.closest('.shopify-block').hidden = true
        }
    }

    fetchData() {
        this.didProductRecommendationLoad = true;
        HELPER_UTIL.fetchData({
            method: 'GET',
            responseType: 'text',
            url: `${window.Shopify.routes.root}recommendations/products?product_id=${this.productId}&section_id=${this.recommendationSectionName}&intent=${this.recommendationType}`,
            onsuccess: (textData) => {
                this.generateProductLayouts(textData);
                // this.setProductsContainer().active();
            },
            onerror: (error) => {
                console.log(error);
            },
        });
    }

    connectedCallback() {
        console.log('Complementary products connected');
    }
}


customElements.get('complementary-product') ||
    customElements.define('complementary-product', ComplementaryProducts);
}
